import React, { Component, createRef } from "react";
import { Layout, Typography, Row, Col, Divider} from 'antd';
import { Link } from 'react-router-dom'
import '../../Styles/Global/terminos.scss'
import '../../Styles/Global/footer.scss'
import 'iseeyoutech-widget-web/dist/style.css'
import { Footer } from "antd/lib/layout/layout";

const { Content } = Layout
const { Title, Paragraph, Text } = Typography
/**
 *
 *
 * @export
 * @class Terminos
 * @extends {Component}
 * @description Pagina principal del sistema
 */ 
class Terminos extends Component {

    constructor(props){
        super(props)

    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <Layout className="terminos-page">
                <Content className="terminos-main">
                    <Row gutter={[30, 30]}>
                        <Col xs={24} className="terminos-content">
                            <Title level={1}>Aviso de Privacidad</Title>
                            <Text type="secondary">Última actualización: 16 de julio de 2026</Text>

                            <Paragraph style={{ marginTop: 24 }}>
                            Nexus Nova, con domicilio en Jose Maria Chavez 656, Col. El Encino, C.P. 20240, Aguascalientes, México, es responsable del tratamiento de los datos personales que recaba de sus clientes y usuarios a través de su sitio web y tienda en línea.
                            </Paragraph>
                            <Paragraph>
                            La protección de su información personal es importante para nosotros. Por ello, este Aviso de Privacidad tiene como finalidad informarle cómo recopilamos, utilizamos, almacenamos y protegemos sus datos personales.
                            </Paragraph>

                            <Title level={3}>Datos personales que recabamos</Title>
                            <Paragraph>Podemos solicitar los siguientes datos personales:</Paragraph>
                            <ul>
                                <li>Nombre completo.</li>
                                <li>Domicilio de envío y facturación.</li>
                                <li>Número telefónico.</li>
                                <li>Correo electrónico.</li>
                                <li>Registro Federal de Contribuyentes (RFC), cuando sea necesario para la emisión de facturas.</li>
                                <li>Información de pago (procesada de forma segura mediante proveedores autorizados; no almacenamos datos completos de tarjetas bancarias, salvo que la legislación y las medidas de seguridad aplicables lo permitan).</li>
                            </ul>

                            <Title level={3}>Finalidades del tratamiento de los datos</Title>
                            <Paragraph>Los datos personales serán utilizados para:</Paragraph>
                            <ul>
                                <li>Procesar y confirmar pedidos.</li>
                                <li>Realizar envíos de productos.</li>
                                <li>Emitir facturas.</li>
                                <li>Brindar atención al cliente.</li>
                                <li>Dar seguimiento a garantías, devoluciones o reclamaciones.</li>
                                <li>Informar sobre el estado de los pedidos.</li>
                                <li>Cumplir con obligaciones legales y fiscales.</li>
                            </ul>
                            <Paragraph>Con su consentimiento, también podremos utilizar su información para:</Paragraph>
                            <ul>
                                <li>Enviar promociones y descuentos.</li>
                                <li>Compartir novedades sobre nuevos productos y servicios.</li>
                                <li>Realizar encuestas de satisfacción.</li>
                            </ul>
                            <Paragraph>
                            En cualquier momento podrá solicitar que sus datos dejen de utilizarse para fines promocionales.
                            </Paragraph>

                            <Title level={3}>Transferencia de datos</Title>
                            <Paragraph>Sus datos personales podrán ser compartidos únicamente cuando sea necesario con:</Paragraph>
                            <ul>
                                <li>Empresas de mensajería para la entrega de productos.</li>
                                <li>Instituciones financieras y plataformas de pago para procesar transacciones.</li>
                                <li>Autoridades competentes cuando exista una obligación legal.</li>
                            </ul>
                            <Paragraph>No venderemos ni comercializaremos sus datos personales.</Paragraph>

                            <Title level={3}>Medidas de seguridad</Title>
                            <Paragraph>
                            Implementamos medidas administrativas, técnicas y físicas razonables para proteger sus datos personales contra daño, pérdida, alteración, acceso o uso no autorizado.
                            </Paragraph>

                            <Title level={3}>Derechos del titular</Title>
                            <Paragraph>
                            Usted podrá ejercer sus derechos de acceso, rectificación, cancelación y oposición (ARCO), así como revocar el consentimiento otorgado para el tratamiento de sus datos personales, mediante una solicitud enviada a nuestro correo electrónico de contacto.
                            </Paragraph>
                            <Paragraph>La solicitud deberá incluir:</Paragraph>
                            <ul>
                                <li>Nombre del titular.</li>
                                <li>Medio para recibir respuesta.</li>
                                <li>Descripción clara de la solicitud.</li>
                                <li>Documentación que permita acreditar su identidad cuando sea necesario.</li>
                            </ul>

                            <Title level={3}>Uso de cookies</Title>
                            <Paragraph>
                            Nuestro sitio web puede utilizar cookies y tecnologías similares para mejorar la experiencia de navegación, analizar el tráfico del sitio y ofrecer contenido personalizado.
                            </Paragraph>
                            <Paragraph>
                            Puede configurar su navegador para rechazar las cookies; sin embargo, algunas funciones del sitio podrían verse afectadas.
                            </Paragraph>

                            <Title level={3}>Cambios al aviso de privacidad</Title>
                            <Paragraph>
                            Nos reservamos el derecho de modificar el presente Aviso de Privacidad en cualquier momento para cumplir con cambios legales o por necesidades operativas. Las modificaciones serán publicadas en nuestro sitio web.
                            </Paragraph>

                            <Title level={3}>Contacto</Title>
                            <Paragraph>
                            Para cualquier duda relacionada con este Aviso de Privacidad, puede comunicarse con nosotros a través de:
                            </Paragraph>
                            <ul>
                                <li>Nombre de la empresa: Nexus Nova</li>
                                <li>Domicilio: Jose Maria Chavez 656, Col. El Encino, C.P. 20240, Aguascalientes, México</li>
                                <li>Teléfono: +52 (449) 976 88 41</li>
                            </ul>
                            <Paragraph>
                            Al utilizar nuestro sitio web y proporcionar sus datos personales, usted manifiesta haber leído y comprendido el presente Aviso de Privacidad.
                            </Paragraph>
                        </Col>
                    </Row>
                </Content>
                <Footer
                    className="footer"
                >   
                    <Row className="footer-wrapper">
                        <Col xs={24} md={8} className="footer-about">
                            <img src="/images/nexus-footer.svg" className="footer-logo"/>
                            <Paragraph className="footer-descripcion">Traemos lo que necesitas de cualquier parte del mundo y nos encargamos de todos los detalles.</Paragraph>
                        </Col>
                        <Col xs={24} md={8} className="footer-directorio">
                            <Title level={3}>Directorio</Title>
                            <nav>
                                <Link to="/">Inicio</Link>
                                {/*<Link to="#">Preguntas Frecuentes</Link>*/}
                                <Link to="/terminos">Terminos y Condiciones</Link>
                                <Link to="/login">Iniciar Sesión</Link>
                            </nav>
                        </Col>
                        <Col xs={24} md={8} className="footer-sucursales">
                            <Title level={3}>Sucursales</Title>
                            <div className="footer-listado">
                                <Paragraph className="sucursal">
                                    <strong> Nexus Nova Aguascalientes </strong> <br />
                                    {/* San Emilion 304, 20310 Viñedos San Felipe, Ags. <br /> */}
                                    Jose Maria Chavez 656 Col. El Encino CP 20240 Aguascalientes México <br />
                                    <a target="_blank" href="tel:+524499768841">+52 (449) 976 88 41</a>
                                </Paragraph>
                                
                                {/*<Paragraph className="sucursal">
                                    <strong> Nexus Nova Guadalajara </strong> <br/>
                                    Justicia 91, Colonia Esperanza, CP 44300 Guadalajara, Jalisco <br/>
                                    +524492041003
                                </Paragraph>
                                <Paragraph className="sucursal">
                                    <strong> Nexus Nova Guanajuato </strong> <br/>
                                    Boulevard Brisas de Sarandi #304 Interior manzana 4 bodega #146 Colonia brisas del Campestre CP 37669 León Guanajuato México <br/>
                                    +524792325305
                                </Paragraph>*/}
                            </div>
                        </Col>
                        <Col span={24}><Divider/></Col>
                        <Col span={24}>
                            <Row justify={"space-between"} align={"middle"}>
                                <Text>@2025 Copyright I SEE YOU TECHNOLOGIES</Text>
                                <Text>Nexus Nova Todos los derechos Reservados </Text>
                            </Row>
                        </Col>
                    </Row>
                </Footer>
            </Layout>
        )
    }

}

export default (props) => {

    return <Terminos {...props}/>
}